import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import Slider from "../../components/Slider";
import { setvolume } from "../../redux/actions/player";
import { volumeToggle } from "../../redux/actions/styles";
import VolumeUpRoundedIcon from "@mui/icons-material/VolumeUpRounded";
import VolumeOffRoundedIcon from "@mui/icons-material/VolumeOffRounded";

const Volume = () => {
  const dispatch = useDispatch();
  const AC = bindActionCreators({ setvolume, volumeToggle }, dispatch);

  const { volumeOpen } = useSelector((state) => state.styles);
  const { volume } = useSelector((state) => state.player);

  const volumeRef = useRef(50);
  const [playerVolume, setplayerVolume] = useState(50);

  useEffect(() => {
    AC.setvolume(playerVolume / 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playerVolume]);

  function onMute() {
    volumeRef.current = playerVolume;
    setplayerVolume(0);
  }

  function onResume() {
    setplayerVolume(volumeRef.current);
  }

  return (
    <div className={`volume ${volumeOpen ? "volume-open" : ""}`}>
      <div className="bg-dark" onClick={() => AC.volumeToggle(false)} />
      <div className="container">
        <p className="vol-text">{playerVolume}</p>
        <Slider min={0} max={100} value={playerVolume} onChange={(e) => setplayerVolume(e.target.value)} />
        {volume ? (
          <div className="icon" onClick={onMute}>
            <VolumeUpRoundedIcon />
          </div>
        ) : (
          <div className="icon" onClick={onResume}>
            <VolumeOffRoundedIcon />
          </div>
        )}
      </div>
    </div>
  );
};

export default Volume;
